import * as React from 'react';
import { connect, useSelector } from 'react-redux';
import './PolicyDetails.css';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { DASHBOARD, GET_BLING_INSURANCE, PERSONAL_INSURANCE, FNOL_SUBMIT_CLAIM } from '../../../routes/routes';
import { showComingSoon, showAddNewItem, showSendIMEIModal, showBankingDetails, showCancelPolicyEdit, showCallMeModal, showUpdatePolicyModal } from '../../../actions/modalActions';
import { Card, Accordion, Image } from 'react-bootstrap';
import { BLING_BRAND_NEW_COVER_TYPE, BLING_LIKE_NEW_COVER_TYPE, BLING_SCREEN_FIX_COVER_TYPE, PRODUCT_BLING, SET_CUSTOMER_DATA } from '../../../constants/constants';
import { BLING_SCREEN_FIX_PRODUCT_ID, BLING_LIKE_NEW_PRODUCT_ID, BLING_BRAND_NEW_PRODUCT_ID, AMEND_POLICY_BLING } from '../../../constants/products';
import { addProduct, checkBlingReplacementValue, getBlingRiskItemDetailedInfo, setBlingItemDetails, setIsInEdit, setReplacementValue, setSelectedBlingDetail, setStartReplacementValue, updateBlingRiskItemToQuote } from '../../../actions/salesActions';
import { HashLink as Link } from 'react-router-hash-link';
import { navigateTo } from '../../../actions/navigationActions';
import { setPolicyReducer } from '../../../actions/profileActions';
import ReplacementValueCheck from './ReplacementValueCheck/ReplacementValueCheck';
import { setCoverFromPersonalInsurance, clearSelectedDamages, resetFNOL, setStep } from '../../../actions/claimSubmitActions';

class PolicyDetailsCellphone extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            isInEdit: false,
            showMore: false,
            reminderDismissed: false,
            accordian0Open: false,
            updateAccordian0Open: false,
            accordian1Open: false,
            updateAccordian1Open: false,
            accordian2Open: false,
            updateAccordian2Open: false,
        }
        this.dismissIMEIReminder = this.dismissIMEIReminder.bind(this);
        this.editPolicyInfo = this.editPolicyInfo.bind(this);
        this.submitAClaim = this.submitAClaim.bind(this);
        this.handleNewItem = this.handleNewItem.bind(this);
        this.addNewProduct = this.addNewProduct.bind(this);
        this.handleCallMeBackModal = this.handleCallMeBackModal.bind(this);
        this.handleAccordianArrow = this.handleAccordianArrow.bind(this);
        this.handleShowIMEIModal = this.handleShowIMEIModal.bind(this);
        this.showCancelEdit = this.showCancelEdit.bind(this);
        this.saveEdit = this.saveEdit.bind(this);
        this.setSelectedPortable = this.setSelectedPortable.bind(this);
        this.showUpdatePolicyModal = this.showUpdatePolicyModal.bind(this);
    }

    handleCallMeBackModal() {
        this.props.handleCallMeBack()
    }

    handleShowIMEIModal() {
        this.setSelectedPortable();
        this.props.dispatchShowSendIMEIModal();
    }

    setSelectedPortable() {
        this.props.dispatchAction(setPolicyReducer(SET_CUSTOMER_DATA, 'selectedPortablePossession', this.props.CellphoneCover))
    }

    async dismissIMEIReminder() {
        await this.setState({
            reminderDismissed: !this.state.showMore
        })
    }

    async editPolicyInfo() {
        if (this.props.profile.countryId === 157) {
            this.props.dispatchShowComingSoon();
            return;
        }
        this.setSelectedPortable();
        this.props.dispatchShowUpdatePolicy(AMEND_POLICY_BLING);
    }

    async submitAClaim(cover) {
        let riskItemSelectable = { id: cover.id, productName: "Portable possessions", riskItems: [cover] }
        await this.props.dispatchAction(resetFNOL());
        await this.props.dispatchAction(clearSelectedDamages());
        await this.props.dispatchAction(setCoverFromPersonalInsurance(riskItemSelectable));
        await this.props.dispatchAction(setStep(1, 1));
        await this.props.dispatchAction(navigateTo(FNOL_SUBMIT_CLAIM));
    }

    handleNewItem() {
        if (this.props.profile.countryId === 157) {
            this.props.handleCallMeBack()
        }
        else {
            this.props.redirectTo(GET_BLING_INSURANCE);
        }
    }

    addNewProduct() {
        if (this.props.profile.countryId === 157) {
            this.props.handleCallMeBack()
        }
        else {
            this.props.dispatchAddProduct(PRODUCT_BLING);
        }
    }

    handleAccordianArrow(e: any) {
        switch (e) {
            case 0:
                if (this.state.accordian0Open) {
                    this.setState({ accordian0Open: false });
                }
                else {
                    this.setState({ accordian0Open: true });
                }
                this.setState({ accordian1Open: false });
                this.setState({ accordian2Open: false });
                break;
            case 1:
                if (this.state.accordian1Open) {
                    this.setState({ accordian1Open: false });
                }
                else {
                    this.setState({ accordian1Open: true });
                }
                this.setState({ accordian0Open: false });
                this.setState({ accordian2Open: false });
                break;
            case 2:
                if (this.state.accordian2Open) {
                    this.setState({ accordian2Open: false });
                }
                else {
                    this.setState({ accordian2Open: true });
                }
                this.setState({ accordian0Open: false });
                this.setState({ accordian1Open: false });
                break;
            default:
        }
    }

    async updateRiskItemToQuote() {
        await this.props.dispatchUpdateBlingRiskItemToQuote(this.props.sales.selectedBlingDetail.selectedCoverTypeId);
    }

    async setItemDetails(e: any) {
        await this.props.dispatchSetBlingItemDetails(e);
    }

    async editPolicyRiskItem(filterItem: any) {
        await this.props.dispatchEditBlingPolicyRiskItem(filterItem);
    }

    async setSelectedDetail(filterItem: any) {
        await this.props.dispatchSetSelectedBlingDetail(filterItem);
    }

    async checkReplacementValue() {
        await this.props.dispatchCheckBlingReplacementValue();
    }

    async getRiskItemDetailedInfo(id: any, riskItemType: any) {
        this.props.dispatchGetBlingRiskItemDetailedInfo(id, riskItemType);
    }

    async saveEdit() {
        this.props.dispatchshowBankingDetails();
    }

    async showCancelEdit() {
        this.props.dispatchShowCancelPolicyEdit();
    }

    async showUpdatePolicyModal() {
        this.setSelectedPortable();
        this.props.dispatchShowUpdatePolicy();
    }

    public render() {
        const salesState = this.props.sales;
        const { reminderDismissed, accordian0Open, accordian1Open, accordian2Open } = this.state;
        const profileState = this.props.profile;
        const cover = this.props.CellphoneCover;
        let selectedItem = <div></div>;
        const isMobile = window.innerWidth <= 975;
        if (this.props.sales.isInEdit) {
            selectedItem = <ReplacementValueCheck
                id={salesState.selectedBlingDetail.id}
                description={salesState.selectedBlingDetail.description}
                subDescription={salesState.selectedBlingDetail.subDescription}
                cellPhoneNumber={salesState.selectedBlingDetail.cellPhoneNumber}
                premium={salesState.selectedBlingDetail.premium}
                totalPolicyPremium={salesState.selectedBlingDetail.totalPolicyPremium}
                updateRiskItemToQuote={() => this.updateRiskItemToQuote()}
                setItemDetails={(e) => this.setItemDetails(e)}
                editPolicyRiskItem={(e) => this.editPolicyRiskItem(e)}
                setSelectedDetail={(e) => this.setSelectedDetail(e)}
                checkReplacementValue={() => this.checkReplacementValue()}
                getRiskItemDetailedInfo={(id, riskItemType) => this.getRiskItemDetailedInfo(id, riskItemType)}
                setIsInEdit={(e) => this.props.dispatchSetIsInEdit(e)}
                setReplacementValue={(e) => this.props.dispatchSetReplacementValue(e)}
                setStartReplacementValue={(e) => this.props.dispatchSetStartReplacementValue(e)}
                profileState={this.props.profile}
                salesState={this.props.sales}
            />
        }

        let coverStartDate = (cover.coverStartDate?.toString().trim().length > 0) ? cover.coverStartDate : "";

        return (
            <>
                
                {this.props.sales.isInEdit &&
                    <div id="Update-policy" className="card col-12 mb-3">
                        <div className="card-body text-centerThat decrease monthly">

                            <h3>Update your policy</h3>
                            <p>Here you can edit your replacement value.</p>

                            <p>Hit <b>'Save'</b> to apply your changes, or <b>'Cancel'</b> to undo them.</p>
                            <p><b>Please note:</b> You'll need to confirm your banking details and accept our legal terms to finish updating your policy.</p>

                            <div className="row mt-3 mb-3 update-policy-button-holder">
                                <div className="col-12 col-lg-6 order-lg-1">
                                    <button className="btn btn-outline-white mt-lg-0 mb-2 mt-2 float-lg-right" onClick={this.saveEdit} id='SavePolicyUpdate'>Save</button>
                                </div>

                                <div className="col-12 col-lg-6 order-lg-2 mt-3 mt-lg-0">
                                    <button className="btn btn-outline-white mr-lg-0 mb-2 float-lg-left" onClick={this.showCancelEdit} id='CancelPolicyUpdate'>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {!this.props.sales.isInEdit && <div className="card">
                    {!reminderDismissed && (cover.serialNumber === "" || cover.serialNumber === null) &&
                        <div className="bling-imei-banner mb-9px">
                            <div className="bling-imei-text-holder">
                                <p className="update-imei">Please send us your IMEI number by tapping <Link className="text-underline text-white" onClick={this.handleShowIMEIModal}>here</Link>  <img title="" className="bling-imei-banner-close-img" src="Images/icons-navigation-close-16-px-white.svg" alt="Dismiss" onClick={this.dismissIMEIReminder} /></p>
                            </div>
                        </div>
                    }
                    <div className={(cover.serialNumber !== "" && cover.serialNumber !== null) && !reminderDismissed ? "" : "padding-top"} id="PolicyDetailsBling">
                        <div className="row noma">
                            <div className="col-lg-8 col-md-8 col-12 nopa">
                                <p className="font-size-22px font-weight-bold line-height-normal mb-10px">{cover.description}</p>
                                <div className="mb-10px">
                                    {isMobile && profileState.countryId !== 157 &&
                                        <p className="font-size-16px font-weight-500 line-height-normal mb-5px">Cellphone insurance</p>
                                    }
                                    {isMobile && profileState.countryId === 157 &&
                                        <p className="font-size-16px font-weight-500 line-height-normal mb-5px">Cellphone insurance</p>
                                    }
                                    <p className="font-size-16px font-weight-500 line-height-normal">Phone no. <b>{cover.cellPhoneNumber}</b></p>
                                </div>
                                <div className="mb-15px">
                                    <p className="bling-comprehensive-cover-amount mb-0px">{profileState.currencySymbol} {cover.premium} pm</p>
                                </div>
                                {coverStartDate.length > 0 &&
                                    <div className="mb-2">
                                        <p className="font-weight-normal line-height-normal mb-1px">Cover start date</p>
                                        <p className="font-size-16px font-weight-bold line-height-normal mb-0px">{coverStartDate}</p>
                                    </div>
                                }
                            </div>
                            <div className="col-lg-4 col-md-4 col-12 nopa text-lg-right text-center">
                                {!this.props.sales.isInEdit &&
                                    <div className="bling-update-polic-button-holder">
                                        <div className="mb-10px">
                                            <button className="btn btn-outline-red" onClick={this.editPolicyInfo} id="EditPolicy">Update policy</button>
                                        </div>
                                        <div>
                                            <button className="btn btn-solid-aqua" onClick={() =>this.submitAClaim(cover)}>Submit a claim</button>
                                        </div>
                                    </div>
                                }
                            </div>
                            <div className="col-12 nopa">
                                <hr className="policy-details-hr" />
                                <p className="font-size-16px font-weight-bold mb-3px">Excess amount</p>
                                {cover.excess === "15.00" &&
                                    <p className="excessAmount">{"15% of claim value (min " + profileState.currencySymbol + "1250.00)"}</p> ||
                                    <p className="excessAmount">{profileState.currencySymbol + cover.excess}</p>
                                }
                                <p className="font-weight-normal line-height-normal mb-0px">Insured for {profileState.currencySymbol} {cover.insuredForValue.replace(/\d(?=(\d{3})+\.)/g, '$&,')}</p>
                                <hr className="policy-details-hr mt-14px mb-15px" />
                                <p className="font-size-16px font-weight-bold mb-7px">IMEI no.</p>
                                {(cover.serialNumber === "" || cover.serialNumber === null) &&
                                    <>
                                        <p className="font-weight-normal mb-5px">This is a unique 15-digit serial number that every cellphone has. In the event of a claim, this serial number might be used to help identify the insured cellphone.</p>
                                        <p className="font-weight-normal mb-0px"><b>Please note:</b> Without an IMEI number, we may not be able to process your claim.</p>
                                        <div className="mt-10px">
                                            <button className="btn btn-solid-warning" onClick={this.handleShowIMEIModal}>Send IMEI no.</button>
                                        </div>
                                    </>
                                }
                                {(cover.serialNumber !== "" && cover.serialNumber !== null) &&
                                    <p className="font-weight-normal mb-0px">{cover.serialNumber}</p>
                                }
                                <hr className="policy-details-hr mt-14px mb-15px" />
                                {!this.props.sales.isInEdit &&
                                    <div id="DetailsDiv" className="new-ssp-faq-block">
                                        <Accordion>
                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="0" onClick={() => this.handleAccordianArrow(0)}>
                                                    <div className="row align-items-center">
                                                        <div className="col">
                                                            Regular cellphone user
                                                        </div>
                                                        <div className={"accordion-arrow-svg" + (this.state.eventKey0Open ? ' isRotatednew' : '')}></div>
                                                    </div>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="0">
                                                    <Card.Body>
                                                        <div className="form-group row noma">
                                                            <label className="col-sm-6 nopa col-form-label">Initial and Surname</label>
                                                            <div className="col-sm-6 nopa">
                                                                <p className="form-control-plaintext text-lg-right">{cover.initials} {cover.surname}</p>
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="1" onClick={() => this.handleAccordianArrow(1)}>
                                                    <div className="row align-items-center">
                                                        <div className="col">
                                                            Insurance history
                                                        </div>
                                                        <div className={"accordion-arrow-svg" + (this.state.eventKey1Open ? ' isRotatednew' : '')}></div>
                                                    </div>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="1">
                                                    <Card.Body>
                                                        <div className="form-group row noma">
                                                            <label className="col-sm-6 nopa col-form-label">No. of claims in the last 2 years</label>
                                                            <div className="col-sm-6 nopa">
                                                                <p className="form-control-plaintext text-lg-right">{cover.numberOfClaims}</p>
                                                            </div>
                                                        </div>
                                                        <div className="form-group row noma">
                                                            <label className="col-sm-6 nopa col-form-label">Last claim</label>
                                                            <div className="col-sm-6 nopa">
                                                                <p className="form-control-plaintext text-lg-right">{cover.lastStolenClaim}</p>
                                                            </div>
                                                        </div>
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>}
                <div className="mb-2">
                    <div className="d-lg-block d-none" >
                        {this.props.sales.isInEdit &&
                            selectedItem}
                    </div>
                </div>
                <div className="d-lg-none d-block" id="PolicyDetailsMobile" style={{ display: "none" }}>
                    {this.props.sales.isInEdit && selectedItem
                    }
                </div>
            </>
        )
    }
}
const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        ssp: state.ssp,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchShowComingSoon: () => dispatch(showComingSoon()),
        dispatchShowSendIMEIModal: () => dispatch(showSendIMEIModal()),
        dispatchAddProduct: (action) => dispatch(addProduct(action)),
        dispatchShowAddNewItem: () => dispatch(showAddNewItem()),
        dispatchSetIsInEdit: (value) => dispatch(setIsInEdit(value)),
        dispatchSetSelectedBlingDetail: (value) => dispatch(setSelectedBlingDetail(value)),
        dispatchGetBlingRiskItemDetailedInfo: (coverId, numVar) => dispatch(getBlingRiskItemDetailedInfo(coverId, numVar)),
        dispatchUpdateBlingRiskItemToQuote: (value) => dispatch(updateBlingRiskItemToQuote(value)),
        dispatchSetBlingItemDetails: (value) => dispatch(setBlingItemDetails(value)),
        dispatchCheckBlingReplacementValue: () => dispatch(checkBlingReplacementValue()),
        dispatchSetReplacementValue: (value) => dispatch(setReplacementValue(value)),
        dispatchSetStartReplacementValue: (value) => dispatch(setStartReplacementValue(value)),
        dispatchshowBankingDetails: (value) => dispatch(showBankingDetails()),
        dispatchShowCancelPolicyEdit: (value) => dispatch(showCancelPolicyEdit()),
        dispatchShowBankingDetails: () => dispatch(showBankingDetails()),
        handleCallMeBack: () => dispatch(showCallMeModal(true)),
        dispatchShowUpdatePolicy: (value) => dispatch(showUpdatePolicyModal(value, '')),
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PolicyDetailsCellphone);
